import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import Form148 from '../constructors/taskDescription/components/pharmacy/form148.tsx';
import Form14804 from '../constructors/taskDescription/components/pharmacy/Form148-04.tsx';
import Form14804Back from '../constructors/taskDescription/components/pharmacy/Form148-04Back.tsx';
import Form148Back from '../constructors/taskDescription/components/pharmacy/form148Back.tsx';
import Form107UNP from '../../pages/constructors/taskDescription/components/pharmacy/Form107-U-NP.tsx';
import Form107_1_Back from '../constructors/taskDescription/components/pharmacy/Form107_1_Back.tsx';
import Form107_1 from '../constructors/taskDescription/components/pharmacy/Form107_1.tsx';
import MainLayout from '../../components/Layout/MainLayout';
import NewChatWizardTopMenu from '../startChatWizard/NewChatWizardTopMenu';
import ButtonWithProgress from '../../components/common/ButtonWithProgress';
import chatApi from '../../api/chatApi';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getMedicineNameStage, getTestingstageTaskOnTask } from '../../api/chatApi/chatApi.ts';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '1280px',
    margin: '0 auto',
    marginTop: 50,
    height: '90vh',
    '& input:disabled': {
      backgroundColor: '#ffffff !important',
      color: '#000000 !important',
      '-webkit-text-fill-color': '#000000 !important',
      opacity: '1 !important',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#ffffff !important',
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23) !important',
      },
      '& input': {
        backgroundColor: '#ffffff !important',
        color: '#000000 !important',
        '-webkit-text-fill-color': '#000000 !important',
      },
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23) !important',
    },
  },
  dropArea: {
    position: 'relative',
    width: '100%',
    minHeight: '600px',
    border: '1px dashed #ccc',
    marginBottom: '20px',
  },
}));

interface FormInput {
  id: number;
  value: string;
  right: boolean;
}

interface FormSvg {
  id: number;
  type: string;
  x: number;
  y: number;
  isWrongAnswer: boolean;
}

interface FormData {
  [key: number]: {
    inputs: { [key: number]: FormInput };
    svgs: FormSvg[];
  };
}

interface IStage {
  routePath: string;
  activeStage: number;
  code: string;
  legend_id?: number;
  routhPathCode: string;
}

interface Stage {
  routePath: string
  routhPathCode: string
  activeStage: number
  code: string
  legend_id?: number
  testingstage_id: number
}

const PharmacyPage = () => {
  const c = useStyles();
  const [task, setTask] = useState<number>(0);
  const [formData, setFormData] = useState<FormData>({});
  const [formCheckboxStates, setFormCheckboxStates] = useState<{ [key: number]: { inputs: { [key: number]: boolean }; svgs: { [key: number]: boolean } } }>({});
  const [taskForms, setTaskForms] = useState<{ id: number; name: string }[]>([]);
  const history = useHistory()
  const location = useLocation();
  const [stages, setStages] = useState<IStage[]>([]);
  const [isAlreadyPassed, setIsAlreadyPassed] = useState(false)
  const [userValidityInput, setUserValidityInput] = useState<string>('');
  const [taskId, setTaskId] = useState<number>(0)
  const [currentStage, setCurrentStage] = useState<any>(null)

  async function unfinishedTaskHandler() {
    try {
      const response = await chatApi.unfinishedTask()
      setTaskId(response.result.taskId)
    } catch (err) {
      console.log('при выполнении unfinishedTaskHandler', err);
    }
  }

  useEffect(() => {
    unfinishedTaskHandler()
  }, [])

  useEffect(() => {
    async function fetchAllStages() {
      try {
        const result = await getTestingstageTaskOnTask();
        setStages(result.data.testingstage_task_on_task);
        const currentStage = result.data.testingstage_task_on_task.find((stage: Stage) => stage.routePath === '/pharmacy');
        setCurrentStage(currentStage)
      } catch (error) {
        console.error('Ошибка при загрузке этапов:', error);
      }
    }
    fetchAllStages();
  }, []);

  const [medicineNameStage, setMedicineNameStage] = useState<string>('')

  async function getNameStage() {
    if (!taskId || !currentStage) {
      return
    }
    
    try {
      const result = await getMedicineNameStage({ task_id: taskId })
      
      if (result?.data?.MedicineNameStage) {
        const matchingStage = result.data.MedicineNameStage.find((item: any) => 
          item.testingstage_id === currentStage.testingstage_id
        )
        const stageName = matchingStage?.name
        setMedicineNameStage(stageName || '')
      } else {
        setMedicineNameStage('')
      }
    } catch (error) {
      console.error('Error fetching stage name:', error)
      setMedicineNameStage('')
    }
  }

  useEffect(() => {
    getNameStage()
  }, [taskId, currentStage])

  async function getHistoryStage() {
    try {
      const res = await chatApi.getTestingStageHistory()
      const activeStage = stages.find((el) => el.routhPathCode === "pharmacy")
      const result = res.result.find((el) => el.activeStageId === activeStage?.activeStage)
      if (result) {
        setIsAlreadyPassed(true)
      }

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getHistoryStage()
  }, [stages])

  useEffect(() => {
    const fetchUnfinishedTask = async () => {
      try {
        const response = await chatApi.unfinishedTask();
        setTask(response.result.taskId);
      } catch (err) {
        console.error('Error fetching unfinished task:', err);
      }
    };
    fetchUnfinishedTask();
  }, []);

  useEffect(() => {
    const fetchRecipeTaskDetails = async () => {
      if (task === 0) {
        return;
      }

      try {
        const response = await chatApi.getRecipeTaskDetailByTask(task);
        processResponseArray(response.result);
      } catch (error) {
        console.error('Error fetching recipe task details:', error);
      }
    };

    fetchRecipeTaskDetails();
  }, [task]);

  const processResponseArray = (responseArray: any[]) => {
    const data = responseArray.reduce((acc, item) => {
      const { recipe, recipeDetailsTypesId, id, value, x, y } = item;

      if (!acc[recipe.id]) {
        acc[recipe.id] = { inputs: {}, svgs: [] };
      }

      if (recipeDetailsTypesId === 1) {
        let adjustedX = x;
        let adjustedY = y;

        // Масштабирование координат для разных форм
        switch (recipe.id) {
          case 1: // Form107_1
            adjustedY = y * 0.66;
            adjustedX = x * 0.68;
            break;
          case 2: // Form107_1_Back
            adjustedY = y * 0.54;
            adjustedX = x * 0.67;
            break;
          case 3: // Form107UNP
            adjustedY = y * 0.65;
            adjustedX = x * 0.67;
            break;
          case 4: // Form148-04
            adjustedY = y * 0.79;
            adjustedX = x * 0.65;
            break;
          case 5: // Form148-04Back
            adjustedY = y * 0.46;
            adjustedX = x * 0.67;
            break;
          case 6: // Form148
            adjustedY = y * 0.46;
            adjustedX = x * 0.66;
            break;
          case 7: // Form148Back
            adjustedY = y * 0.65;
            adjustedX = x * 0.67;
            break;
          default:
            adjustedY = y * 0.82;
            adjustedX = x * 0.82;
        }

        acc[recipe.id].svgs.push({ id, type: value, x: adjustedX, y: adjustedY, isWrongAnswer: false });
      } else {
        acc[recipe.id].inputs[item.cell] = {
          id,
          value,
          right: false,
        };
      }

      return acc;
    }, {});

    setFormData(data);

    const initialCheckboxStates = Object.keys(data).reduce((acc, formId) => {
      const form = data[formId];
      acc[formId] = {
        inputs: Object.keys(form.inputs || {}).reduce((inputAcc, inputId) => {
          inputAcc[inputId] = form.inputs[inputId]?.right || false;
          return inputAcc;
        }, {}),
        svgs: form.svgs.reduce((svgAcc, svg) => {
          svgAcc[svg.id] = svg.isWrongAnswer || false;
          return svgAcc;
        }, {}),
      };
      return acc;
    }, {});
    setFormCheckboxStates(initialCheckboxStates);


    const forms = responseArray.reduce((acc, item) => {
      if (!acc.find(form => form.id === item.recipe.id)) {
        acc.push({
          id: item.recipe.id,
          name: item.recipe.name
        });
      }
      return acc;
    }, []);
    setTaskForms(forms);
  };

  const handleCheckboxStateChange = useCallback((formId, { inputs, svgs }) => {
    setFormData((prev) => ({
      ...prev,
      [formId]: {
        ...prev[formId],
        inputs: {
          ...prev[formId].inputs,
          ...Object.entries(inputs).reduce((acc, [key, value]) => {
            acc[key] = { ...prev[formId].inputs[key], right: value };
            return acc;
          }, {}),
        },
        svgs: prev[formId].svgs.map((svg) => ({
          ...svg,
          isWrongAnswer: svgs[svg.id] ?? svg.isWrongAnswer,
        })),
      },
    }));

    setFormCheckboxStates((prev) => ({
      ...prev,
      [formId]: { inputs, svgs },
    }));
  }, []);

  const handleInputChange = useCallback((formId, inputId, value) => {
    setFormData((prev) => ({
      ...prev,
      [formId]: {
        ...prev[formId],
        inputs: {
          ...prev[formId].inputs,
          [inputId]: {
            ...prev[formId].inputs[inputId],
            value,
          },
        },
      },
    }));
  }, []);

  const renderFormComponent = (formId) => {
    switch (formId) {
      case 1:
        return Form107_1;
      case 2:
        return Form107_1_Back;
      case 3:
        return Form107UNP;
      case 4:
        return Form14804;
      case 5:
        return Form14804Back;
      case 6:
        return Form148;
      case 7:
        return Form148Back;
      default:
        return null;
    }
  };

  const handleSave = async () => {
    try {
      const payload = Object.values(formData).flatMap((form) => {
        const inputsPayload = Object.entries(form.inputs || {}).map(([key, input]: [string, unknown]) => {
          const inputData = input as FormInput;
          
          return {
            recipe_taskdetail_id: inputData.id,
            value: inputData.right,
          };
        });

        const svgsPayload = (form.svgs || []).map((svg: FormSvg) => ({
          recipe_taskdetail_id: svg.id,
          value: svg.isWrongAnswer,
        }));

        return [...inputsPayload, ...svgsPayload];
      });

      // Добавляем userInput для поля с cell: 99 (поле срока действия)
      if (userValidityInput && userValidityInput.trim() !== '') {
        let validityFieldId = null;
        
        Object.values(formData).forEach((form) => {
          if (form.inputs && form.inputs[99]) {
            validityFieldId = form.inputs[99].id;
          }
        });

        if (validityFieldId) {
          const validityInputItem = payload.find(item => item.recipe_taskdetail_id === validityFieldId);
          if (validityInputItem) {
            validityInputItem.userInput = userValidityInput;
          } else {
            payload.push({
              recipe_taskdetail_id: validityFieldId,
              userInput: userValidityInput
            });
          }
        } else {
          payload.push({
            cell: 99,
            formId: 3,
            userInput: userValidityInput
          });
        }
      }

      await chatApi.createRecipeUserTaskProceed(payload);
      
    } catch (error) {
      console.error('Ошибка при отправке ответов:', error);
    } finally {
      goToNextStage()
    }
  };

  async function setHistoryStage(testingStage) {
    try {
      await chatApi.setTestingStageHistory(testingStage)
    } catch (error) {
      console.warn(error)
    }
  }

  // Функция для перехода на следующий этап, если текущий этап уже пройден
  async function goToNextStage() {
    const currentPath = location.pathname;
    const currentStageObj = stages.find(stage => stage.routePath === currentPath);

    if (!currentStageObj) return;

    setHistoryStage(currentStageObj.activeStage);
    const currentActiveStage = currentStageObj.activeStage;

    const sortedNextStages = stages
      .filter(stage => stage.activeStage > currentActiveStage)
      .sort((a, b) => a.activeStage - b.activeStage);

    if (sortedNextStages.length === 0) {
      console.warn('Нет доступных следующих стадий.');
      return;
    }

    let nextIndex = 0;

    if (sortedNextStages[nextIndex].code === 'conclusion') {
      nextIndex += 1;

      if (nextIndex >= sortedNextStages.length) {
        nextIndex = 0;
      }
    }

    const finalNextStage = sortedNextStages[nextIndex];

    history.push(finalNextStage.routePath);

  }


  return (
    <MainLayout desktopHeader={<NewChatWizardTopMenu title={medicineNameStage || 'Экспертиза рецепта'} />} title={medicineNameStage || 'Экспертиза рецепта'}>
      <Box className={c.root}>
        {isAlreadyPassed ? (
          <Typography variant="h6" style={{ textAlign: 'center', marginTop: '20px' }}>
            Вы уже прошли этот этап
          </Typography>
        ) : (
          [...taskForms]
            .sort((a, b) => a.id - b.id)
            .map((form) => {
              const Component = renderFormComponent(form.id);

              if (!Component) return null;

              return (
                <Accordion key={form.id}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>{form.name}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className={c.dropArea}>
                      <Component
                        initialValues={formData[form.id] || { inputs: {}, svgs: [] }}
                        formCheckboxStates={formCheckboxStates[form.id] || { inputs: {}, svgs: {} }}
                        isReadOnly={true}
                        isShow={true}
                        isChatPage={true}
                        {...((form.id === 1 || form.id === 3) && {
                          userValidityInput: userValidityInput,
                          onUserValidityInputChange: setUserValidityInput
                        })}
                        onCheckboxStateChange={(checkboxStates) => handleCheckboxStateChange(form.id, checkboxStates)}
                        onInputChange={(inputId, value) => handleInputChange(form.id, inputId, value)}
                      />
                      <Divider />
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })
        )}

        {isAlreadyPassed ? (
          <div style={{ alignSelf: 'center', margin: '10px', marginTop: 50 }}>
            <ButtonWithProgress variant="contained" color="primary" onClick={goToNextStage}>
              Следующий этап
            </ButtonWithProgress>
          </div>
        ) : (
          <div style={{ alignSelf: 'center', margin: '10px', marginTop: 50 }}>
            <ButtonWithProgress variant="contained" color="primary" onClick={handleSave}>
              Отправить ответы
            </ButtonWithProgress>
          </div>
        )}
      </Box>
    </MainLayout>
  );
};

export default PharmacyPage;


